let permissionGranted = false;
const maxNotifications = 1;
let notificationCount = 0;

export const notificationsService = (() => {
	Notification.requestPermission().then(result => {
		permissionGranted = result === "granted";
	});

	const createNotification = (
		title: string,
		options: NotificationOptions
	) => {
		if (
			!permissionGranted ||
			notificationCount >= maxNotifications ||
			document.visibilityState === "visible"
		) {
			return null;
		}

		const notification = new Notification(title, options);

		const onVisibilityChange = () => {
			if (document.visibilityState === "visible") {
				notification.close();
			}
		};

		notification.addEventListener("show", () => {
			notificationCount++;
		});
		notification.addEventListener("close", () => {
			notificationCount--;
			document.removeEventListener(
				"visibilitychange",
				onVisibilityChange
			);
		});
		notification.addEventListener("click", () => {
			notificationCount--;
		});

		document.addEventListener("visibilitychange", onVisibilityChange);

		return notification;
	};

	return { createNotification };
})();
